import { useContext } from 'react';

import { MiddleOfficeConfigContext } from '../../MiddleOfficeConfigContext';
import { MiddleOfficeConfigContextType } from '../../types/MiddleOfficeConfigContextType';

export const useMiddleOfficeConfig = (): MiddleOfficeConfigContextType => {
  const context = useContext(MiddleOfficeConfigContext);

  if (!context) {
    throw new Error(
      'useMiddleOfficeConfig must be used within a MiddleOfficeConfigProvider',
    );
  }
  return context;
};
